module.exports = __webpack_public_path__ + "static/media/finalTick.bb30f34f.svg";